import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"


import {reactive, ref} from "vue";
import {router} from '@/router'
import type {FormInstance} from "element-plus";
import request from '../../../api'
import VerificationPhone from "./verificationPhone.vue";
import VerificationCode from "./verificationCode.vue";
import {ElMessage, UploadInstance, UploadProps} from "element-plus";
import axios from "axios";

export default /*#__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props, { emit: emits }) {

const verificationCode=ref()
const register = ref<FormInstance>();
const adminRegisterCode = ref('');

// const props = defineProps({
//   isShow1: Boolean,
//   isShow2: Boolean,
// });



function updateParentShow(show1: boolean, show2: boolean) {
  emits("updateShow", show1, show2);
}

const checkAccount = (rule, value, callback) => {
  if (!value) {
    callback(new Error("Please enter your Username."));
  } else {
    value = value.toString();
    if (value.length > 200) return callback(new Error("Username is too long!"));
    return callback();
  }
};

const checkPhoneNumber = (rule: any, value: any, callback: any) => {
  let phoneString = value.toString();
  if (!value) {
    callback(new Error("Please enter your phone number."));
  }
  setTimeout(() => {
    if (!Number.isInteger(value)) {
      callback(new Error("Please enter numbers!"));
    } else {
      console.log(phoneString.length);
      if (phoneString.length !== 11) {
        callback(new Error("The phone number must be 11 digits!"));
      } else {
        callback();
      }
    }
  }, 300);
};

const validatePass = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please enter your password!"));
  } else {
    if (ruleForm.checkPass !== "") {
      if (!register.value) return;
      register.value.validateField("checkPass", () => null);
    }
    callback();
  }
};
const validatePass2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please check your password!"));
  } else if (value !== ruleForm.pass) {
    callback(new Error("The passwords are different!"));
  } else {
    callback();
  }
};

const checkVerificationCode =(rule:any,value:any,callback:any)=>{
  if(!value){
    callback(new Error("Please enter the verification code!"))
  }else{
    ruleForm.verificationCode=verificationCode.value.verCode
    if(verificationCode.value.verificateFlag()) return callback()
    return callback(new Error("The verification code is wrong!"))
  }
}
const options=[
  {
    value: 1,
    label: 'user',
  },
  {
    value: 0,
    label: 'admin',
  }
  // ,
  // {
  //   value: 2,
  //   label: 'root',
  // }
]
const ruleForm = reactive({
  account: "",
  pass: "",
  checkPass: "",
  phoneNumber: "",
  verificationCode:"",
  institute:"",
  authority:1
});

const rules = reactive({
  pass: [{validator: validatePass, trigger: "blur"}],
  checkPass: [{validator: validatePass2, trigger: "blur"}],
  phoneNumber: [{validator: checkPhoneNumber, trigger: "blur"}],
  account: [{validator: checkAccount, trigger: "blur"}],
  verificationCode: [{validator: checkVerificationCode, trigger: "blur"}]
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl){
    console.log("直接返回")
    return;
  }
  if(ruleForm.authority===0 && adminRegisterCode.value!=='fzz6C2OIeVZHZnMLLiV/tULIVsHs1AiLpu0LxeWp18lyyUTtgU2F5ReA65YJpMIxZ922Br2winu49BuZJs2ie3XWxrI31hUgzyMSc2kkpVT0hq1'){
    ElMessage.error("Admin registration code is incorrect. Verify the code or register as a user.")
    return;
  }
  if(!verificationCode.value.verificateFlag()){
    let formInstance = new FormData()
    formInstance.append('authority','214')
    console.log(formInstance)
    console.log(formInstance.get('authority'))
    alert("The verification code is wrong!")
    return false
  }
  formEl.validate((valid) => {
    if (valid) {
      console.log("submit!");
      let formInstance = new FormData()
      formInstance.append('authority',ruleForm.authority.toString())
      formInstance.append('code',verificationCode.value.verCode)
      formInstance.append('password',ruleForm.pass)
      formInstance.append('telephone',ruleForm.phoneNumber)
      formInstance.append('username',ruleForm.account)
      formInstance.append('institute',ruleForm.institute)
      const instance = axios.create({
        baseURL:'/api',
        //baseURL:'http://localhost:7996',
        timeout:1000,
        headers:{'Content-Type':'multipart/form-data;charset=utf-8'}
      })
      instance
          .post('/user/register',formInstance)
          .then(res=>{
            console.log("结果:")
            console.log(res)
            updateParentShow(true, false);
            // router.push('/login')
            if (res.status === 200 && res.data.msg === "Success") {
              console.log("yes");
              ElMessage.success('Register successfully, now you can log in.')
            }else if (res.data.msg === "User already exist!"){
              console.log("no");
              ElMessage.error('Register failed since the user already exists.')
            }else if (res.data.msg === "User name is null!"){
              console.log("no");
              ElMessage.error('Register failed since the user name is null.')
            }
          })
          .catch(err=>{
            ElMessage.error('Register failed.')
            console.log("出错了:")
            console.log(err)
          })
    } else {
      console.log("error submit!");
      return false;
    }
  });
};



// const resetForm = (formEl: FormInstance | undefined) => {
//   console.log(ruleForm)
//   if (!formEl) return;
//   formEl.resetFields();
// };

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "register",
    ref: register,
    model: ruleForm,
    "status-icon": "",
    rules: rules,
    "label-width": "200px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Username",
        prop: "account"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.account,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.account) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Password",
        prop: "pass"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.pass,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.pass) = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Check password",
        prop: "checkPass"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.checkPass,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.checkPass) = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Phone number",
        prop: "phoneNumber"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.phoneNumber) = $event)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "University/Institute",
        prop: "institute"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.institute,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.institute) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Authority",
        prop: "Authority"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: ruleForm.authority,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.authority) = $event)),
            class: "m-2",
            placeholder: "user",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (ruleForm.authority===0)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "Admin registration code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: adminRegisterCode.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((adminRegisterCode).value = $event)),
                type: "password"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, { label: "Verification" }, {
        default: _withCtx(() => [
          _createVNode(VerificationCode, {
            ref_key: "verificationCode",
            ref: verificationCode
          }, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(register.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Register")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})